import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';

localStorage.removeItem('token');
 
@Injectable({providedIn: 'root'})
export class TodosService {
  
  constructor(private http: HttpClient) {}
  

  login(username:any, password:any) {

    // const url = 'https://mainapi.hsc.gov.ua/auth-server/oauth/token';
    const url = 'http://10.123.171.4/auth-server/oauth/token'

    const body = new HttpParams()
      .set('username', username)
      .set('password', password)
      .set('grant_type', 'password');

    return this.http.post<any> (url, body).subscribe(
        data => {
          localStorage.removeItem('token');
          const token = data.access_token;
          localStorage.setItem('token', token);
        },
      err => console.log(err)
    );
  }

}


